<template>
	<div class="owl-carousel">
      <div class="item" v-for="(items, i) in arr">
				<p class="status">{{i+1}} из {{arr.length}}</p>
				<ul class="grid s_1 m_2 l_4">
					<li v-for="item in items">
						<div class="block">
							<a v-if="item.img" :href="item.href" class="img" :style="`background-image: url(${item.img})`"></a>
              <div class="bottomBlock">
                <a v-if="item.text" :href="item.href" class="slTitle">{{item.text}}</a>
                <div class="priceAndBuy">
                  <div class="priceContainer">
                      <p class="sale">
                        <span v-if="item.priceText">{{item.priceText}}</span>
                        <span v-if="item.oldPrice" v-html="item.oldPrice" class="oldPrice"></span>
                      </p>
                      <p class="price" v-if="item.price" v-html="item.price"></p>
                  </div>
                  <a class="buy  waves-effect waves-light" v-if="item.href" :href="item.href">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <path d="M501.333,213.331h-90.388L296.792,47.289c-3.333-4.854-9.969-6.073-14.833-2.75c-4.854,3.344-6.083,9.979-2.75,14.833    l105.846,153.958H126.945L232.792,59.373c3.333-4.854,2.104-11.49-2.75-14.833c-4.833-3.323-11.479-2.104-14.833,2.75    L101.055,213.331H10.667C4.771,213.331,0,218.102,0,223.998c0,5.896,4.771,10.667,10.667,10.667h13.533l65.207,204.938    c5.667,17.781,22,29.729,40.656,29.729h251.875c18.656,0,34.99-11.948,40.656-29.74l65.206-204.927h13.534    c5.896,0,10.667-4.771,10.667-10.667C512,218.102,507.229,213.331,501.333,213.331z M402.26,433.123    c-2.833,8.896-11,14.875-20.323,14.875H130.063c-9.323,0-17.49-5.979-20.323-14.865L46.589,234.664h418.823L402.26,433.123z"/>
                    </svg>
                  </a>
                </div>
              </div>
						</div>
					</li>
				</ul>
      </div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {
			itemCount: 4
		}
	},

	computed: {
		arr(){
			let arr = [];
			let v = [];
			for(let i = 0; i < this.items.length; i++){
				v.push(this.items[i]);
				if(((i+1) % this.itemCount) == 0){
					arr.push(v);
					v = [];
				}else if((i+1) == this.items.length){
					arr.push(v);
					v = [];
				}
			}
			// console.log(arr);
			return arr
		}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: (this.items.length / this.arr.length) <= this.itemCount ? true : false,
				nav: true,
				autoHeight: true,
				onChanged: function(e){
					let str = '';
					setTimeout(function() {
						$(e.target).closest('.global-slider-container').find('.owl-item').each(function() {
							if($(this).hasClass('active')){
								try{
									str = $(this).find('.status')[0].innerText;
									$(e.target).closest('.js-top').find('.sliderInnerText').text(str);
								}catch(e){
									console.log(e);
								}
							}
						});
					}, 0);
				},
				onInitialized: function() {
					$('.owl-next, .owl-prev').addClass('waves-effect waves-light');
				}
			}
		});
	},
	mounted() {
		var sizeArr = () => {
			var w = $(window).width();
			if((w >= 320) && (w <= 639)){
				this.itemCount = 1;
			}
			else if((w >= 640) && (w <= 1179)){
				this.itemCount = 2;
			}
			else if(w >= 1180){
				this.itemCount = 4;
			}
		}
		sizeArr();
		$(window).on('resize',function() {
			sizeArr();
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-popSlider {
		background-color: #f7f8fd;
		// height: 225px;

		.owl-carousel {
			.owl-item{
				.item {
					// overflow: hidden;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding-top: 4px;
					.block{
						height: 345px;
						width: 100%;
						background-color: white;
						box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);
						@include single-transition();
					 .img{
             height: 215px;
             width: 100%;
             display: block;
             background-position: center;
             background-repeat: no-repeat;
           }
           .bottomBlock{
             padding: 0 30px 30px;
             .slTitle{
               font-weight: 500;
               font-size: rem(14);
               line-height: rem(24);
               color: #393d4c;
               text-decoration: none;
               height: rem(48);
               overflow: hidden;
               margin-bottom: 11px;
               display: block;
               &:hover{
                 text-decoration: underline;
               }
             }
             .priceAndBuy{
               display: flex;
               justify-content: space-between;
               align-items: center;
               .priceContainer{
                 .sale{
                   font-size: rem(14);
                   line-height: rem(26);
                   color: #393d4c;
                   font-weight: 600;
                   height: rem(27);
                    .oldPrice{
                      color: #006eb6;
                      font-weight: bold;
                      b{
                        font-weight: bold;
                      }
                      i{
                        font-style: normal;
                        font-size: rem(12)
                      }
                    }
                   }
                 .price{
                      font-size: rem(18);
                      line-height: rem(26);
                      color: #393d4c;
                      font-weight: bold;
                      height: rem(27);
                      i{
                        font-style: normal;
                        font-size: rem(14)
                      }
                    }
               }
               .buy{
                 margin-top: 2px;
                 width: 38px;
                 height: 38px;
                 border: 1px solid #0f77ba;
                 border-radius: 100%;
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 @include single-transition();
                 svg{
                   width: 24px;
                   height: 24px;
                   path{
                     @include single-transition();
                     fill: #0f77ba;
                   }
                 }
                 &:hover{
                   background-color: #006eb6;
                   @include single-transition();
                   svg{
                     path{
                       @include single-transition();
                       fill: #fff;
                     }
                   }
                 }
               }
             }
           }
					 &:hover{
						 @include single-transition();
						 transform: translateY(-4px);
						 box-shadow: 0px 8px 30px rgba(242, 242, 242, 4);
					 }
					}
					.status{
						display: none;
					}
				}
			}
		}
		.owl-nav{
			position: absolute;
			top: -85px;
			right: 0;
			display: flex;

			.owl-next, .owl-prev{
				width: 45px;
				height: 45px;
				font-size: 0;
				background-color: #fff;
				border: 1px solid rgb(244, 244, 245);
				background-image: url('../img/slArr.png');
				background-position: center;
				background-repeat: no-repeat;
				border-radius: 100%;
				margin-left: 15px;
				@include single-transition();
				box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);

				&.owl-prev{
					transform: rotate(180deg);
				}
				&:hover{
					background-color: #006eb6;
					border-color: #006eb6;
					filter: brightness(100%);
					background-image: url('../img/slArr2.png');
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// popProduct.vue?74eb48e4